import axios from "axios";
import { getAccessToken } from "./authSession";
import { API_BASE_URL } from "../config";

const getAuthHeaders = () => {
    const token = getAccessToken();

    if (!token) {
        window.location.href = "/";
    }

    return {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    };
};

export const getBusinessSettingsView = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/business/settings/view`, getAuthHeaders());
        return response.data;
    } catch (error) {
        console.error("Error fetching business settings view:", error);
        throw error;
    }
};

export const updateBusinessSettingsControlPlaneScope = async (payload) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}/business/settings/master-scope`,
            payload,
            getAuthHeaders(),
        );
        return response.data;
    } catch (error) {
        console.error("Error updating business settings master scope:", error);
        throw error;
    }
};

export const updateBusinessSettingsMasterScope = updateBusinessSettingsControlPlaneScope;

export const updateBusinessSettingsPricingScope = async (payload) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}/business/settings/pricing-scope`,
            payload,
            getAuthHeaders(),
        );
        return response.data;
    } catch (error) {
        console.error("Error updating business settings pricing scope:", error);
        throw error;
    }
};

export const getBusinessPricingTopSkusPreview = async (scopeType = "business", scopeRef = null) => {
    try {
        const params = { scope_type: scopeType };
        if (scopeRef) params.scope_ref = scopeRef;
        const response = await axios.get(`${API_BASE_URL}/business/settings/pricing-top-skus`, { ...getAuthHeaders(), params });
        return response.data;
    } catch (error) {
        console.error("Error fetching pricing top skus preview:", error);
        throw error;
    }
};

export const getBusinessPricingScopes = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/business/settings/pricing-scopes`, getAuthHeaders());
        return response.data;
    } catch (error) {
        console.error("Error fetching business pricing scopes:", error);
        throw error;
    }
};

export const upsertEnterprisePricingOverride = async (enterpriseCode, payload) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}/business/settings/pricing-scope/enterprise/${encodeURIComponent(enterpriseCode)}`,
            payload,
            getAuthHeaders(),
        );
        return response.data;
    } catch (error) {
        console.error("Error saving enterprise pricing override:", error);
        throw error;
    }
};

export const deleteEnterprisePricingOverride = async (enterpriseCode) => {
    try {
        const response = await axios.delete(
            `${API_BASE_URL}/business/settings/pricing-scope/enterprise/${encodeURIComponent(enterpriseCode)}`,
            getAuthHeaders(),
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting enterprise pricing override:", error);
        throw error;
    }
};

export const upsertOrganizationPricingOverride = async (organizationId, payload) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}/business/settings/pricing-scope/organization/${encodeURIComponent(organizationId)}`,
            payload,
            getAuthHeaders(),
        );
        return response.data;
    } catch (error) {
        console.error("Error saving organization pricing override:", error);
        throw error;
    }
};

export const deleteOrganizationPricingOverride = async (organizationId) => {
    try {
        const response = await axios.delete(
            `${API_BASE_URL}/business/settings/pricing-scope/organization/${encodeURIComponent(organizationId)}`,
            getAuthHeaders(),
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting organization pricing override:", error);
        throw error;
    }
};

export const runMasterCatalogJob = async (job) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/business/settings/master-catalog/run`,
            { job },
            getAuthHeaders(),
        );
        return response.data;
    } catch (error) {
        console.error("Error starting master catalog job:", error);
        throw error;
    }
};

export const getCompetitorPriceImportStatus = async () => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/business/settings/competitor-prices/status`,
            getAuthHeaders(),
        );
        return response.data;
    } catch (error) {
        console.error("Error loading competitor price import status:", error);
        throw error;
    }
};

export const runCompetitorPriceImport = async () => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/business/settings/competitor-prices/run`,
            {},
            getAuthHeaders(),
        );
        return response.data;
    } catch (error) {
        console.error("Error starting competitor price import:", error);
        throw error;
    }
};
